const sessionStorage = window.sessionStorage

export default {
  getItem (key) {
    try {
      return sessionStorage.getItem(key)
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  setItem (key, value) {
    try {
      sessionStorage.setItem(key, value)
      return true
    } catch (err) {
      console.error(err)
      return false
    }
  },
  removeItem (key) {
    try {
      sessionStorage.removeItem(key)
      return true
    } catch (err) {
      console.error(err)
      return false
    }
  },
  clear () {
    try {
      sessionStorage.clear()
      return true
    } catch (err) {
      console.error(err)
      return false
    }
  }
}
